import React from 'react';
export function PubHeader() {
  return <div className="w-full" data-id="element-29">
      <div className="border-b-2 border-dark pt-4 pb-[14px] px-5 flex items-center justify-center max-w-[720px] mx-auto" data-id="element-30">
        <span className="font-lora text-[14px] font-bold tracking-[0.2em] uppercase text-dark" data-id="element-31">
          Women's Health Report
        </span>
      </div>
      <div className="max-w-[720px] mx-auto text-center pt-[5px] pb-2 px-5 border-b border-border" data-id="element-32">
        <span className="font-inter text-[10px] tracking-[0.15em] uppercase text-[#aaaaaa] font-medium" data-id="element-33">
          Sponsored Advertorial
        </span>
      </div>
    </div>;
}